import a, { useState as r, useCallback as c } from "react";
const d = {
  display: "none"
};
function u(e) {
  let {
    id: n,
    value: t
  } = e;
  return a.createElement("div", {
    id: n,
    style: d
  }, t);
}
function s(e) {
  let {
    id: n,
    announcement: t,
    ariaLiveType: i = "assertive"
  } = e;
  const o = {
    position: "fixed",
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return a.createElement("div", {
    id: n,
    style: o,
    role: "status",
    "aria-live": i,
    "aria-atomic": !0
  }, t);
}
function m() {
  const [e, n] = r("");
  return {
    announce: c((i) => {
      i != null && n(i);
    }, []),
    announcement: e
  };
}
export {
  u as HiddenText,
  s as LiveRegion,
  m as useAnnouncement
};
//# sourceMappingURL=accessibility.esm.js.map
